export class Address {
    constructor(value: any = null) {
        if (value) {
            this.address_Id = value.address_id || value.Address_Id;
            this.address1 = value.address1 || value.Address1;
            this.address2 = value.address2 || value.Address2;
            this.address3 = value.address3 || value.Address3;
            this.city = value.city || value.City;
            this.country = value.country || value.Country;
            this.latitude = value.latitude || -1;
            this.longitude = value.longitude || -1;
            this.state = value.state || value.State;
            this.zipCode = value.zipCode || value.PostalCode;
        }
    }

    address_Id: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    zipCode: string;
    zip4: string;
    country: string = 'US';
    latitude: number;
    longitude: number;
}